<div class="star-rating">
  <ng-container *ngFor="let star of [].constructor(params.value); let i = index">
    <span class="star" [class.filled]="i < params.value">*</span>
  </ng-container>
</div>
